<ng-container *transloco="let t">
    <div class="bazis-modal-wrap">
        <div class="bazis-modal__header">
            <figure class="bazis-figure">
                <img
                    src="/assets/images/mascots/hello.svg"
                    alt="mascot"
                />
            </figure>
        </div>

        <div class="bazis-modal__content">
            <h2>{{ t('onboarding.start.title') }}</h2>
            <p class="bazis-text_secondary">
                {{ t('onboarding.start.description') }}
            </p>
        </div>

        <div class="bazis-modal__footer">
            <bazis-button
                color="action"
                size="large"
                class="bh-block"
                (click)="startOnboarding()"
            >
                {{ t('onboarding.start.actionStart') }}
            </bazis-button>
            <bazis-button
                fill="outline"
                size="large"
                class="bh-block"
                (click)="closeModal()"
            >
                {{ t('onboarding.start.actionEnd') }}
            </bazis-button>
        </div>
    </div>
</ng-container>
